import { getAllAthletesPaginated } from '../../../api/app.api';
import { UserLimited } from '../../../utils';

// Shared utility functions for dashboard components
export const userDataGetter = (page: number, limit: number, payload: Record<string, any>) =>
    getAllAthletesPaginated({
        page,
        limit,
        ...payload,
    });

// Mapper used by both Dashboard and SprintDashboard - returns dimensions with image_url, page, and hasMore
// This format is required by DimensionFilterBuilder component
export const userDataMapper = (response: any) => {
    return {
        dimensions: response.data.map((u: UserLimited) => ({
            title: `${u.name}`,
            image_url: `${u.profile_photo}`,
            uuid: u.uuid,
        })),
        page: response.meta.current_page,
        hasMore: Boolean(response.links.next),
    };
};
